export default {"src":"/_next/static/media/bg-hero.389ed632.svg","height":749,"width":1280,"blurWidth":0,"blurHeight":0};